import React, { useEffect } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useQuery, useMutation } from 'components/graphql'
import { Form, Checkbox, Select } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import Divider from 'components/Divider'
import { updateProductProperties } from '../../gql/mutation'
import { appConfig } from 'gql/query'
import get from 'lodash/get'
import { loadAppConstants } from 'gql/query'
import { useTranslation } from 'react-i18next'
import { changeLabel } from 'sections/utils'
import listProductGroups from 'sections/options/sections/GlobalCashRegisters/pages/ProductGroups/gql/listProductGroups'

const Options = ({ data = {}, formData, mutations: { updateItem } }) => {
	const [t, i18n] = useTranslation()
	const { data: { getAppConfig = {} } } = useQuery(appConfig.specialProductExpenses)
	const expenseNames = get(getAppConfig, 'specialProductExpenses', [])
	const options = expenseNames.map((item, i) => ({ value: i + 1, label: item || `${t('product_section.strings.expenses')} ${i + 1}` }))
	const [mutate] = useMutation(updateProductProperties)
	const { data: dataRestriction } = useQuery(loadAppConstants, { variables: { type: 84, language: i18n.language }, fetchPolicy: 'cache-first' })
	const optionsRestriction = changeLabel(dataRestriction?.loadAppConstants, 'product_section.fields.restriction_option', t)

	return (
		<ContentBlock>
			<Form initialValues={formData} onSubmit={updateItem} smartSubmit>
				<Row>
					<Col xs>
						<Select
							field='linkExpense'
							label={t('product_section.fields.income_expenses_credit')}
							options={options}
							isClearable
						/>
						<Checkbox field='halfNotAllowed' label={t('product_section.fields.cannot_divided')} />
						<Checkbox field='waste' label={t('product_section.fields.against_waste')} />
						<Checkbox field='isWarehouse' label={t('product_section.fields.depository')} />
					</Col>
					<Col xs>
						<Select
							label={t('product_section.fields.triggers_command')}
							field='checkOutCommandId'
							remoteOptions={{ query: loadAppConstants, variables: { type: 40, language: i18n.language } }}
						/>
					</Col>
					<Col xs>
						<Select
							noForm
							value={data.properties ? data.properties.YouthProtection : null}
							label={t('product_section.fields.youth_protection')}
							options={optionsRestriction}
							onChange={({ value }) => {
								mutate({
									variables: {
										productId: data.id,
										fields: { YouthProtection: value }
									},
									optimisticResponse: {
										__typename: 'Mutation',
										cashAssist: {
											__typename: 'CA_Mutation',
											updateProductProperties: {
												__typename: 'Product',
												id: data.id,
												mod_ver: -1,
												properties: { YouthProtection: value, __typename: 'ProductProperties' }
											}
										}
									}
								})
							}} />
					</Col>
				</Row>
				<Divider/>
				<Row>
					<Col xs>
						<Select
							label={`${t('common.strings.group')} 1`}
							field='group1Id'
							remoteOptions={{ query: listProductGroups, variables: { filter: { groupId: '1' } }, fetchPolicy: 'cache-and-network' }}
							valueField='id'
							labelField='name'
							isClearable
						/>
						<Select
							label={`${t('common.strings.group')} 2`}
							field='group2Id'
							remoteOptions={{ query: listProductGroups, variables: { filter: { groupId: '2' } }, fetchPolicy: 'cache-and-network' }}
							valueField='id'
							labelField='name'
							isClearable
						/>
						<Select
							label={`${t('common.strings.group')} 3`}
							field='group3Id'
							remoteOptions={{ query: listProductGroups, variables: { filter: { groupId: '3' } }, fetchPolicy: 'cache-and-network' }}
							valueField='id'
							labelField='name'
							isClearable
						/>
					</Col>
				</Row>
			</Form>
		</ContentBlock>
	)
}
export default Options
